
import { defineComponent, reactive, watchEffect, toRefs, computed, ref } from 'vue';
import { emojiUrl, emojiMap, emojiName, faceUrl, bigEmojiList } from '../../utils/emojiMap';
import { onClickOutside } from '@vueuse/core';
import TUIAegis from '../../../../../utils/TUIAegis';
import { handleErrorPrompts } from '../../../utils';

const Face = defineComponent({
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    isMute: {
      type: Boolean,
      default: () => false,
    },
    isH5: {
      type: Boolean,
      default: () => false,
    },
    parentID: {
      type: String,
      default: () => '',
    },
  },
  setup(props: any, ctx: any) {
    const data = reactive({
      emojiUrl,
      emojiMap,
      emojiName,
      faceUrl,
      bigEmojiList:(window as any)?.TUIKitTUICore?.isOfficial && bigEmojiList || [],
      show: false,
      currentIndex: 0,
      isMute: false,
      transDom: false,
    });

    const dialog: any = ref();

    watchEffect(() => {
      data.show = props.show;
      data.isMute = props.isMute;
    });

    const toggleShow = () => {
      const main: any = document.getElementsByClassName('face-main')[0];
      if (!data.isMute) {
        main.style.display = main.style.display === 'none' ? 'flex' : 'none';
      }
      if (main.style.display === 'none') {
        selectFace(0);
      }
      toggleH5Show();
    };

    const toggleH5Show = () => {
      const parent = document.getElementById(props.parentID);
      const main = document.getElementsByClassName('face-H5-main')[0];
      if (props.isH5) {
        parent?.appendChild(main);
      }
    };

    onClickOutside(dialog, () => {
      const main: any = document.getElementsByClassName('face-main')[0];
      if (main) {
        main.style.display = 'none';
      }
    });

    const select = async (item: string, index: number) => {
      const options: any = {
        name: item,
      };
      if (data.currentIndex === 0) {
        options.type = 'emo';
        options.url = emojiUrl + emojiMap[item];
        options.template = `<img src="${emojiUrl + emojiMap[item]}">`;
        if (!props.isH5) {
          toggleShow();
        }
        return ctx.emit('send', options);
      }
      try {
        await Face.TUIServer.sendFaceMessage({
          // Change large expression display field
          index: data.bigEmojiList[data.currentIndex - 1].icon,
          data: data.bigEmojiList[data.currentIndex - 1].list[index],
        });
        TUIAegis.getInstance().reportEvent({
          name: 'messageType',
          ext1: 'typeFace',
        });
      } catch (error) {
        handleErrorPrompts(error, props);
      }
      if (!props.isH5) {
        toggleShow();
      }
    };

    const list = computed(() => {
      const emojiList = [data.emojiName];
      for (let i = 0; i < data.bigEmojiList.length; i++) {
        emojiList.push(data.bigEmojiList[i].list);
      }
      return emojiList;
    });

    const selectFace = (index: number) => {
      data.currentIndex = index;
    };

    return {
      ...toRefs(data),
      toggleShow,
      select,
      selectFace,
      list,
      dialog,
    };
  },
});
export default Face;
